<template>
    <div id="gas-price">
        <div class="d-flex flex-row align-items-center view-selector">
            <button v-for="(item, index) in gasPrices"
                    :key="item.network"
                    class="d-flex btn"
                    :class="{ 'active': index === selectedNetworkIndex }"
                    @click="handleButtonClick(index)">
                <span>
                    {{ item.network.toUpperCase() }}
                </span>
            </button>
        </div>
        <div class="row justify-content-center info gas-price mx-0 px-0">
            <a :href="`${globalChartsRoute}#gas-prices`"
               class="col-4 px-0 text-center border-right">
                <div class="label">
                    <translate translation-key="header.slow" />
                </div>
                <div class="value">
                    {{ gasPrices[selectedNetworkIndex].slow }}
                    <translate translation-key="header.gwei" />
                </div>
            </a>
            <a :href="`${globalChartsRoute}#gas-prices`"
               class="col-4 px-0 text-center border-right">
                <div class="label">
                    <translate translation-key="header.standard" />
                </div>
                <div class="value">
                    {{ gasPrices[selectedNetworkIndex].standard }}
                    <translate translation-key="header.gwei" />
                </div>
            </a>
            <a :href="`${globalChartsRoute}#gas-prices`"
               class="col-4 px-0 text-center">
                <div class="label">
                    <translate translation-key="header.fast" />
                </div>
                <div class="value">
                    {{ gasPrices[selectedNetworkIndex].fast }}
                    <translate translation-key="header.gwei" />
                </div>
            </a>
        </div>
        <div class="row justify-content-center info gas-price mx-0 px-0">
            <div class="col-12 text-center px-0">
                <div class="powered-by py-1 d-flex justify-content-center align-items-center">
                    <translate translation-key="header.poweredBy"
                               fallback="Powered by" />&nbsp;
                    <div>{{ dataSource[selectedNetworkIndex] }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue';

    interface GasPrice {
        network: string;
        slow: number;
        standard: number;
        fast: number;
    }

    defineProps<{
        gasPrices: GasPrice[];
        globalChartsRoute: string;
    }>();

    const selectedNetworkIndex = ref(0);
    const dataSource = ['Etherscan', 'Etherscan', 'Etherscan'];

    const handleButtonClick = (index: number) => {
        selectedNetworkIndex.value = index;
    };
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/design-system/variables" as variables;

.gas-price {
    color: variables.$baseBlack;

    a {
        transition: 0.2s;

        &:hover {
            opacity: 0.7;
            text-decoration: none !important;
        }
    }

    .label,
    .powered-by {
        color: legacyVariables.$name-pill;
        font-size: 13px;
        font-weight: 600;
    }

    .value {
        color: variables.$baseBlack !important;
        font-size: 14px;
        font-weight: 700;
    }

    .powered-by {
        border-radius: 6px;
        background-color: legacyVariables.$light;
        font-size: 10px;
    }
}

.dark-theme {
    .tippy-content {
        .powered-by {
            background-color: #2f034b;
        }

        .gas-price {
            .label,
            .powered-by {
                color: #d3d3d3 !important;
            }

            .value {
                color: variables.$baseWhite !important;
            }
        }
    }
}
</style>
